(function () {
  'use strict';

  var CLOSE_DELAY = 200;
  var DEFAULT_CAT = 'wah';
  var closeTimer  = null;

  function init() {
    var triggerItem = document.querySelector('.mm-courses__trigger-item');
    var menu        = document.getElementById('mm-courses');

    if (!triggerItem || !menu) return;

    // ── Open / close ────────────────────────────────────────────────────────

    function open() {
      clearTimeout(closeTimer);
      if (!menu.classList.contains('is-open')) {
        activateCat(DEFAULT_CAT);
      }
      menu.classList.add('is-open');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        menu.classList.remove('is-open');
      }, CLOSE_DELAY);
    }

    // Keep open while mouse is over the trigger <li>
    triggerItem.addEventListener('mouseenter', open);
    triggerItem.addEventListener('mouseleave', scheduleClose);

    // Keep open while mouse is inside the fixed menu panel
    menu.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });
    menu.addEventListener('mouseleave', scheduleClose);

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        clearTimeout(closeTimer);
        menu.classList.remove('is-open');
      }
    });

    // ── Category switching ───────────────────────────────────────────────────

    function activateCat(key) {
      var cats   = menu.querySelectorAll('.mm-courses__cat-item');
      var panels = menu.querySelectorAll('.mm-courses__panel');

      cats.forEach(function (cat) {
        cat.classList.toggle('is-active', cat.dataset.mmCat === key);
      });

      panels.forEach(function (panel) {
        var isTarget = panel.dataset.mmPanel === key;
        panel.classList.toggle('is-active', isTarget);
      });
    }

    menu.querySelectorAll('.mm-courses__cat-item').forEach(function (cat) {
      cat.addEventListener('mouseenter', function () {
        activateCat(cat.dataset.mmCat);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
